export class UserAA {
  // implements IDicoType {
  public id: number | null = null;
  public login: string | null = null;
  public userName = "";
  public email = "";
  public type = "";
  public groupes: string[] = [];
  public profilsADPU: IProfil[] = [];

  constructor(json?: UserAA) {
    if (json != null) {
      this.id = json.id;
      this.login = json.login;
      this.userName = json.userName;
      this.email = json.email;
      this.groupes = json.groupes;
      this.profilsADPU = json.profilsADPU;
    }
  }
}

export interface IProfil {
  code: string;
  nom: string;
  isDefaut: boolean;
  droits: IDroit[];
}

export interface IDroit {
  code: string;
  ecriture: boolean;
  lecture: boolean;
}

// export function fromAPI(json: DicoType) {
//   return {
//     id: json.id,
//     code: json.code,
//     name: json.name,
//     regex: json.regex,
//     updated_by: json.updated_by,
//     children:
//       json.children == null
//         ? null
//         : json.children.map((item) => {
//             const a = DicoType.fromAPI(item);
//             return a;
//           }),
//     data_type_parent:
//       json.data_type_parent == null
//         ? null
//         : this.fromAPI(json.data_type_parent),
//     updated_at_format:
//       json.updated_at == null
//         ? "?"
//         : new Date(json.updated_at).toLocaleDateString() +
//           " à " +
//           new Date(json.updated_at).toLocaleTimeString(),
//   };
// }
// export function toAPI(json: DicoType) {
//   return {
//     id: json.id,
//     code: json.code,
//     name: json.name,
//     id_type: json.id_type,
//   };
// }
// export default {
//   // fromAPI,
//   toAPI,
// };
